import React, { useEffect, useState } from 'react'
import { SelectPicker, Loader, FlexboxGrid } from 'rsuite';
import axios from 'axios';
import globalIP from '@/GlobelIP';
import { ControlRow2 } from './costing-page';

const CopyCosting = ({
    fieldData,
    setFieldData,
    setShowTables,
    setCostingTableData,
    btnshow,
    selectedCosting,
    setSelectedCosting
}) => {
    const [costingAllData, setCostingAllData] = useState([]);
    const fetchData = async () => {
        try {
            // Fetch initial data to get the total count
            const { meta: { pagination: { total } } } = await (await fetch(`${globalIP}/api/costings?populate=*`)).json();
            const allData = [];
            const pageData = await (await fetch(`${globalIP}/api/costings?populate=*&pagination[pageSize]=${total}`)).json();
            allData.push(...pageData.data);
            // console.log('allData', allData);
            const costingsdata = allData.map(item => ({
                label: item.attributes.ProductId,
                value: item
            }));
            setCostingAllData(costingsdata);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const [productAllData, setProductAllData] = useState([]);
    const fetchProductData = async () => {
        try {
            let costingProductFilter = '';
            if (costingAllData.length > 0) {
                const costingFilter = costingAllData.map(item => `filters[id][$eq]=${item.label}`).join('&');
                costingProductFilter = `&${costingFilter}`;
            }
            const { meta: { pagination: { total } } } = await (await fetch(`${globalIP}/api/products?populate=*${costingProductFilter}`)).json();
            const allData = [];
            const pageData = await (await fetch(`${globalIP}/api/products?populate=*${costingProductFilter}&pagination[pageSize]=${total}`)).json();
            allData.push(...pageData.data);
            const productsdata = allData.map(item => ({
                label: item.attributes.ProductName + " - " + item.attributes.ProductId,
                value: item.attributes.ProductCode
            }));
            setProductAllData(productsdata);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };


    useEffect(() => {
        //  console.log('fieldData', fieldData); 

    }, [fieldData])

    useEffect(() => { fetchData() }, [])
    useEffect(() => {
        // console.log('costingAllData', costingAllData);
        fetchProductData()
    }, [costingAllData])
    useEffect(() => { 
        // console.log('productAllData', productAllData);

     }, [productAllData])


    return (
        <FlexboxGrid
            style={{ width: btnshow ? "min-content" : "max-content", alignItems: "center",zIndex:"1000000000" }}
        >
            <b>Copy Costing from : </b>
            <SelectPicker
                size='sm'
                data={productAllData}
                value={selectedCosting}
                style={{ width: 160 }}
                cleanable={false}
                onChange={(value) => {
                    if (value) {
                        const costing = costingAllData.find(item => item.value.attributes.prdcd == value)
                        // const product = productAllData.find(item => item.attributes.ProductCode == value)
                        // console.log('found_costing', costing.value.attributes);
                        const { CartonSize, buyername, costingfor, updatedAt, costingtypRev, costingtype, prdcd, ProductId, shippingcost, ...remainingData } = costing?.value?.attributes
                        // console.log('remainingData', remainingData);
                        // setFieldData(remainingData)
                        setShowTables(prev => ({
                            ...prev,
                            accessories: remainingData.CostingAccessory.length ? true : false,
                            material: remainingData.CostingMaterial.length ? true : false,
                            process: remainingData.CostingProcess.length ? true : false,
                            wood: remainingData.CostingWood.length ? true : false,
                            packing: remainingData.Costingpacking.length ? true : false
                        }));

                        setCostingTableData({
                            CostingAccessory: remainingData.CostingAccessory,
                            CostingMaterial: remainingData.CostingMaterial,
                            CostingProcess: remainingData.CostingProcess,
                            CostingWood: remainingData.CostingWood,
                            Costingpacking: remainingData.Costingpacking
                        })
                        setFieldData(prev => ({
                            ...prev, ...remainingData
                        }))
                        setSelectedCosting(value)
                    } else {
                        // setSelectedCosting()
                    }
                }} />
        </FlexboxGrid>
    );

}

export default CopyCosting


